import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import * as echarts from 'echarts'
import moment from 'moment'//导入文件
Vue.prototype.$moment = moment;//赋值使用


Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
